/**
 * My Account menu icons — exact Reference theme assets (local copies).
 * Source: bdvegas theme-icon set (60×60 PNG) + wallet/eye/refresh/member SVGs.
 * No runtime hotlink to third-party CDNs.
 */
import deposit from './icon-deposit.png';
import withdrawal from './icon-withdrawal.png';
import bonuses from './icon-bonuses.png';
import realTimeBonus from './icon-real-time-bonus.png';
import referral from './icon-referral.png';
import winnerBoard from './icon-winner-board.png';
import betRecords from './icon-bet-records.png';
import turnover from './icon-turnover.png';
import records from './icon-records.png';
import profile from './icon-profile.png';
import changePassword from './icon-changepassword.png';
import inbox from './icon-inbox.png';
import customer from './icon-customer.png';
import talk from './icon-talk.png';
import vip from './icon-vip.png';
import promotion from './icon-promotion.png';
import refresh from './icon-refresh.svg';
import eyeOpen from './icon-eye-open.svg';
import eyeClose from './icon-eye-close.svg';
import bonusWalletMark from './icon-bonuswallet.svg';
import memberPic from './memberpic-lv1.svg';

export const ACCOUNT_ICON_SRC = {
  deposit,
  withdrawal,
  bonuses,
  realTimeBonus,
  referral,
  winnerBoard,
  betRecords,
  turnover,
  records,
  profile,
  changePassword,
  inbox,
  customer,
  talk,
  vip,
  promotion,
  refresh,
  eyeOpen,
  eyeClose,
  bonusWalletMark,
  memberPic,
};
